import React from 'react';
import MoreMenu from '../moreMenu';

const FooterMenu = ({ ...props }) => {
  function action() {
    window.open(this.url, '_blank');
  }

  const menuItems = [
    {
      i18nKey: 'footer.privacy',
      url: 'https://chabla.zendesk.com/hc/en-us/articles/213303165-Privacy-Policy',
      action,
    },
    {
      i18nKey: 'footer.terms',
      url: 'https://chabla.zendesk.com/hc/en-us/articles/212710169-Terms-of-Use',
      action,
    },
    { i18nKey: 'footer.feedback', url: 'https://chabla.zendesk.com/hc/en-us/requests/new', action },
  ];

  return <MoreMenu items={menuItems} {...props} />;
};

export default FooterMenu;
